<div>
  <div class="align-middle">
    <hr>
    <h6 class="text-uppercase">
      <span class="collapsible-text" (click)="careTeamToggle()">{{ ( (caseId !==
        undefined) ? 'CASE-CARE-TEAM' : 'PATIENT-CARE-TEAM') | translate:patientLabel}}</span>
      <app-collapsible #patientCareTeamCollapsible *ngIf="memberId !== undefined && caseId === undefined"
        [storageKey]="'patient-care-team-member'" (collapsibleToggle)="patientCareTeamCollapsed=$event">
      </app-collapsible>
      <app-collapsible #caseCareTeamCollapsible *ngIf="caseId !== undefined" [storageKey]="'patient-care-team-case'"
        (collapsibleToggle)="patientCareTeamCollapsed=$event">
      </app-collapsible>
      <div ngbDropdown class="d-inline-block text-left float-right" style="top:-10px;" placement="bottom-right"
        container="body">
        <button *ngIf="!patientCareTeamCollapsed" class="btn btn-outline-primary k-text-uppercase mr-2 pt-2"
          id="dropdownAdd" ngbDropdownToggle>
          {{'ADD' | translate}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownAdd">
          <button class="dropdown-item k-text-uppercase" (click)="addUserIntoTeam()" ngbDropdownItem>
            <i class="fal fa-plus fa-header-nav-icon fa-fw"></i>{{ 'ADD-CARE-TEAM-CHANNELS' | translate }}
          </button>
          <button class="dropdown-item k-text-uppercase" (click)="addNonUserIntoTeam()" ngbDropdownItem>
            <i class="fal fa-plus fa-header-nav-icon fa-fw"></i>{{'ADD-CARE-TEAM' | translate }}
          </button>
        </div>
      </div>
    </h6>
  </div>
  <div *ngIf="!patientCareTeamCollapsed">
    <div *ngIf="team.length === 0 && teamNonUser.length === 0">
      <div class="row" style="color: rgba(0, 0, 0, 0.6);">
        <div class="col-12 p-0">
          <span>{{ 'NO-CARE-TEAM' | translate}}</span>
        </div>
      </div>
    </div>
    <div class="card mb-1 w-100" *ngFor="let careTeam of team">
      <div class="card-body">
        <div class="row">
          <div class="col-7">
            <h6>{{careTeam.userFullName}} <span style="display: inline-flex" *ngIf="careTeam.createdBy">
                <div #tipA kendoTooltip position="top" [tooltipTemplate]="careTeamTimestampTemplate"
                  class="keyboard-accessible" tabindex="0" showOn="none" (focus)="showTooltip(timestampTooltip,tipA)"
                  (mouseover)="showTooltip(timestampTooltip,tipA)" (blur)="hideTooltip(tipA)"
                  (mouseout)="hideTooltip(tipA)" aria-live="polite">
                  <i #timestampTooltip title="" class="fa fa-info-circle pointer"></i>
                  <ng-template #careTeamTimestampTemplate>
                    <span>
                      {{'ADDED-BY-TIMESTAMP' |
                      translate}}&nbsp;<strong>{{careTeam.createdBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
                      translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(careTeam.createdOn),'g')}}</strong>
                    </span>
                  </ng-template>
                </div>
              </span>
            </h6>
          </div>
          <div class="col-5 my-auto text-right p-0">
            <i *ngIf="careTeam.messageAccess" class="fas fa-envelope fa-lg case-team-icon mr-2"
              attr.aria-label="{{'NEW-MESSAGE-HINT' | translate}}" role="button"
              title="{{'NEW-MESSAGE-HINT' | translate}}" (click)="sendMessageToAssignee(careTeam.userName)" tabindex="0"
              (keydown.enter)="sendMessageToAssignee(careTeam.userName)"
              (keydown.space)="sendMessageToAssignee(careTeam.userName)"></i>
            <a *ngIf="careTeam.email" href="mailto:{{careTeam?.email}}" class="dash-label-small mr-2" target="_blank"
              attr.aria-label="{{'NEW-EMAIL-HINT' | translate}}" role="button">
              <i class="fas fa-at fa-lg case-team-icon" title="{{'NEW-EMAIL-HINT' | translate}}">
              </i>
            </a>
            <i class="fas fa-check-square fa-lg case-team-icon mr-2" attr.aria-label="{{'ADD-TASK' | translate}}"
              role="button" title="{{'ADD-TASK' | translate}}"
              (click)="initiateTask(careTeam.userId); $event.stopPropagation();" tabindex="0"
              (keydown.enter)="initiateTask(careTeam.userId); $event.stopPropagation();"
              (keydown.space)="initiateTask(careTeam.userId); $event.stopPropagation();"></i>
            <i class="fas fa-edit fa-lg case-team-icon mr-1" title="{{'EDIT' | translate}}"
              attr.aria-label="{{'EDIT' | translate}}" role="button" (click)="openTeamEditDialog(careTeam)"></i>
            <i class="fas fa-calendar-plus fa-lg case-team-icon mr-2" title="{{'ADD-APPOINTMENT' | translate}}"
              attr.aria-label="{{'ADD-APPOINTMENT' | translate}}" role="button"
              (click)="openAddAppointmentDialog(careTeam)" *ngIf="appointmentsEnabled" tabindex="0"
              (keydown.enter)="openAddAppointmentDialog(careTeam)"
              (keydown.space)="openAddAppointmentDialog(careTeam)"></i>
          </div>
          <div class="col-2 my-auto text-right" *ngIf="false">
            <i class="fas fa-edit fa-lg case-team-icon" title="{{'ASSIGN-TASK' | translate}}"
              attr.aria-label="{{'ASSIGN-TASK' | translate}}" role="button" (click)="openTaskAssignDialog(careTeam)"
              tabindex="0" (keydown.enter)="openTaskAssignDialog(careTeam)"
              (keydown.space)="openTaskAssignDialog(careTeam)"></i>
          </div>
        </div>
        <div class="row">
          <div class="col-11 text-left text-secondary small"><span
              *ngIf="careTeam.subRoleName === null || careTeam.subRoleName === undefined">{{careTeam.roleName}}</span>
            <span *ngIf="careTeam.subRoleName !== null ">{{careTeam.subRoleName}}</span>
            <span *ngIf="careTeam.organization"> | {{careTeam.organization}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="teamNonUser.length > 0 && !patientCareTeamCollapsed">
  <div class="card mb-1 w-100" *ngFor="let careTeamNonUser of teamNonUser">
    <div class="card-body">
      <i *ngIf="careTeamNonUser?.providerAddedAutomatically" class="fas auto-provider"
        [ngClass]="{'fa-info': !careTeamNonUser?.cancelledReferral, 'fa-exclamation-triangle': careTeamNonUser?.cancelledReferral}"
        title="{{ getAutoCreatedHintText(careTeamNonUser.createdOn | date:'medium', careTeamNonUser?.cancelledReferral) }}">
      </i>
      <div class="row">
        <div class="col-8">
          <h6><span
              *ngIf="careTeamNonUser.firstName !== '' && careTeamNonUser.lastName !== ''">{{careTeamNonUser.firstName}}
              {{careTeamNonUser.lastName}}
            </span>
            <span class="montserrat"
              *ngIf="careTeamNonUser.firstName === '' && careTeamNonUser.lastName === '' && careTeamNonUser.organization !== ''">{{careTeamNonUser.organization}}
            </span>
            <span style="display: inline-flex" *ngIf="careTeamNonUser.createdBy">
              <div #tipB kendoTooltip position="top" [tooltipTemplate]="careTeamNonUserTimestampTemplate"
                class="keyboard-accessible" tabindex="0" showOn="none" (focus)="showTooltip(nonUserTooltip,tipB)"
                (mouseover)="showTooltip(nonUserTooltip,tipB)" (blur)="hideTooltip(tipB)" (mouseout)="hideTooltip(tipB)"
                aria-live="polite">
                <i #nonUserTooltip title="" class="fa fa-info-circle pointer"></i>
                <ng-template #careTeamNonUserTimestampTemplate>
                  <span>
                    {{'ADDED-BY-TIMESTAMP' |
                    translate}}&nbsp;<strong>{{careTeamNonUser.createdBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
                    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(careTeamNonUser.createdOn),'g')}}</strong>
                  </span>
                </ng-template>
              </div>
            </span>
          </h6>
        </div>
        <div class="col-4 my-auto text-right p-0">
          <i *ngIf="careTeamNonUser.directAddress && kno2Enabled" class="fas fa-envelope fa-lg case-team-icon mr-2"
            title="{{'NEW-MESSAGE-HINT' | translate}}" attr.aria-label="{{'NEW-MESSAGE-HINT' | translate}}"
            role="button" (click)="sendMessageToAssignee(careTeamNonUser.directAddress, true)" tabindex="0"
            (keydown.enter)="sendMessageToAssignee(careTeamNonUser.directAddress, true)"
            (keydown.space)="sendMessageToAssignee(careTeamNonUser.directAddress, true)"></i>
          <a *ngIf="careTeamNonUser.email && !careTeamNonUser.directAddress" href="mailto:{{careTeamNonUser?.email}}"
            class="dash-label-small mr-2" target="_blank">
            <i class="fas fa-at fa-lg case-team-icon" title="{{'NEW-EMAIL-HINT' | translate}}"
              attr.aria-label="{{'NEW-EMAIL-HINT' | translate}}" role="button">
            </i>
          </a>
          <i class="fas fa-edit fa-lg case-team-icon mr-1" title="{{'EDIT' | translate}}"
            (click)="openTeamNonUserEditDialog(careTeamNonUser.id)" attr.aria-label="{{'EDIT' | translate}}"
            tabindex="0" (keydown.enter)="openTeamNonUserEditDialog(careTeamNonUser.id)"
            (keydown.space)="openTeamNonUserEditDialog(careTeamNonUser.id)" role="button"></i>
          <i class="fas fa-calendar-plus fa-lg case-team-icon mr-2" title="{{'ADD-APPOINTMENT' | translate}}"
            (click)="openAddAppointmentDialog(careTeamNonUser)" *ngIf="appointmentsEnabled"
            attr.aria-label="{{'ADD-APPOINTMENT' | translate}}" role="button" tabindex="0"
            (keydown.enter)="openAddAppointmentDialog(careTeamNonUser)"
            (keydown.space)="openAddAppointmentDialog(careTeamNonUser)"></i>
          <app-collapsible [defaultCollapsed]="true"
            (collapsibleToggle)="updateTeamMemberCollapsed(careTeamNonUser.id, $event)"
            *ngIf="isCollapsible(careTeamNonUser)" style="position: absolute;bottom: -25px;right: 10px;">
          </app-collapsible>
        </div>
        <div class="col-2 my-auto text-right" *ngIf="false">
          <i class="fas fa-edit fa-lg case-team-icon" title="{{'ASSIGN-TASK' | translate}}"
            attr.aria-label="{{'ASSIGN-TASK' | translate}}" role="button"
            (click)="openTaskAssignDialog(careTeamNonUser)" tabindex="0"
            (keydown.enter)="openTaskAssignDialog(careTeamNonUser)"
            (keydown.space)="openTaskAssignDialog(careTeamNonUser)"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-11 text-left text-secondary small"><span
            *ngIf="careTeamNonUser.subRoleName === null || careTeamNonUser.subRoleName === undefined">{{careTeamNonUser.roleName}}
          </span>
          <span *ngIf="careTeamNonUser.subRoleName !== null">{{careTeamNonUser.subRoleName}}</span>
          <span
            *ngIf="careTeamNonUser.organization && (careTeamNonUser.firstName !== '' && careTeamNonUser.lastName !== '')">|
            {{careTeamNonUser.organization}}</span>
        </div>
        <div class="col-12 member-details"
          *ngIf="!collapseTeamMember.get(careTeamNonUser.id) && isCollapsible(careTeamNonUser)">
          <div class="row mt-1" *ngIf="careTeamNonUser.homePhoneNumber">
            <div class="col pl-0" title="{{'HOME-OR-PRACTICE-PHONE' | translate}}">
              <i class="fas fa-phone fa-fw"></i>&nbsp;{{careTeamNonUser.homePhoneNumber | phone}}
              <span *ngIf="careTeamNonUser.homePhoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX' |
                translate}}&nbsp;{{careTeamNonUser.homePhoneNumberExtension}}</span>
            </div>
          </div>
          <div class="row mt-1" *ngIf="careTeamNonUser.cellPhoneNumber">
            <div class="col pl-0" title="{{'CELL' | translate}}">
              <i class="fas fa-mobile-android-alt fa-fw"></i>&nbsp;{{careTeamNonUser.cellPhoneNumber | phone}}
            </div>
          </div>
          <div class="row mt-1" *ngIf="careTeamNonUser.faxNumber">
            <div class="col pl-0" title="{{'FAX-OR-OTHER' | translate}}">
              <i class="fas fa-fax fa-fw"></i>&nbsp;{{careTeamNonUser.faxNumber | phone}}
            </div>
          </div>
          <div class="row mt-1" *ngIf="careTeamNonUser.workPhoneNumber">
            <div class="col pl-0" title="{{'WORK-PHONE' | translate}}">
              <i class="fas fa-phone-office fa-fw"></i>&nbsp;{{careTeamNonUser.workPhoneNumber | phone}}
              <span *ngIf="careTeamNonUser.workPhoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX' |
                translate}}&nbsp;{{careTeamNonUser.workPhoneNumberExtension}}</span>
            </div>
          </div>
          <div class="row mt-1" *ngIf="careTeamNonUser.otherPhoneNumber">
            <div class="col pl-0" title="{{'OTHER-PHONE' | translate}}">
              <i class="fas fa-phone fa-fw"></i>&nbsp;{{careTeamNonUser.otherPhoneNumber | phone}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Detailed info about team member selected -->
<app-team-edit [model]="editDataItemTeam" [isNew]="isNewUserInTeam" [memberId]="memberId" [caseId]="caseId"
  (save)="onSaveTeam($event)" (delete)="onDeleteTeam($event)">
</app-team-edit>

<!-- Detailed info about team member selected -->
<app-team-edit-non-user [model]="editDataItemTeamNonUser" [isNew]="isNewNonUserInTeam" [memberId]="memberId"
  [caseId]="caseId" (save)="onSaveTeamNonUser($event)" (delete)="onDeleteTeamNonUser($event)">
</app-team-edit-non-user>

<!-- Detailed info about team member selected -->
<app-team-assign [model]="editDataItemAssign" (save)="onSaveAssignee($event)" (cancelling)="onCancelAssignee()">
</app-team-assign>

<!--Add provider to care team confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="confirmAddToCareTeamDialogOpened"
  (close)="confirmAddToCareTeamDialogOpened=false;" [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-ADD-CARE-TEAM' | translate }}</p>
  <span class="k-font-weight-bold">{{addingCareTeam.directAddress}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="confirmAddToCareTeamDialogOpened=false;">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="addToCareTeam()" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>